module.exports = __webpack_public_path__ + "static/media/v41.4b8ce4a2.mp4";